import { Pencil, Trash2 } from "lucide-react";
import { AppButton } from "@libs/zapi-ui/custom";
import type { TOrganizationProjectDimension } from "@/zapi-frontend/shared/types/projects";
import { dimensionSubtitle } from "../../lib/dimensionForm";
import { useTranslation } from "react-i18next";

type TProps = {
  dimension: TOrganizationProjectDimension;
  onEdit: () => void;
  onAskDelete: () => void;
};

export function DimensionDisplay(props: TProps) {
  const { dimension, onEdit, onAskDelete } = props;
  const { t } = useTranslation("projects");

  return (
    <>
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="flex min-w-0 flex-1 flex-col gap-1 pt-1">
          <p
            className="truncate text-[14px] font-medium leading-5 text-[#18181b]"
            title={dimension.name}
          >
            {dimension.name}
          </p>
          <p className="truncate text-[14px] leading-[22px] text-[#71717a]">
            {dimensionSubtitle(t, dimension)}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-[5px]">
        <AppButton
          size="icon"
          appearance="text"
          color="zinc950"
          onClick={onEdit}
          aria-label={t("dimensions.editAction")}
          data-testid={`dimension-edit-${dimension.type}`}
        >
          <Pencil className="h-4 w-4" />
        </AppButton>
        <AppButton
          size="icon"
          appearance="text"
          color="red400"
          onClick={onAskDelete}
          aria-label={t("dimensions.deleteAction")}
        >
          <Trash2 className="h-4 w-4" />
        </AppButton>
      </div>
    </>
  );
}
